/**
 * Barrel: pill-shaped buttons (solid fills + rounded-full).
 * Same component as ../ReusableButton — use shape="pill".
 */
import ReusableButton from '../ReusableButton/ReusableButton.js';

export default ReusableButton;
export { ReusableButton };
